import { render, staticRenderFns } from "./RealPageLoading.vue?vue&type=template&id=00aa73c8&scoped=true"
import script from "./RealPageLoading.vue?vue&type=script&lang=js"
export * from "./RealPageLoading.vue?vue&type=script&lang=js"
import style0 from "./RealPageLoading.vue?vue&type=style&index=0&id=00aa73c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa73c8",
  null
  
)

export default component.exports